import { IS_LOCAL, createLoggerFactory } from '@nfctron/nexus-core';

export const createLogger = createLoggerFactory({
	enabledLoggers: {
		app: true,
		tracking: true,
		middleware: true,
		revalidate: true,
	},
	defaultAllowedLevels: IS_LOCAL ? ['debug', 'info', 'warn', 'error'] : ['error'],
});

export const appLogger = createLogger('app');
